import * as React from 'react';
import * as R from 'ramda';
import PureList from '@common/components/list';
import LearningComponentItem from '@modules/learning/components/components-list/item';

class PerformanceComponentsList extends React.Component {
  constructor() {
    super();

    this.state = {
      selected: null,
    };

    this.handleEditComponent = this.handleEditComponent.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const newComponents = R.differenceWith((a, b) => a.id === b.id, nextProps.items, this.props.items);

    // Auto-select newly added component
    if (newComponents.length === 1) {
      // eslint-disable-next-line react/no-will-update-set-state
      this.setState({ selected: newComponents[0].id });
      return;
    }

    // Handle component removal - clear selection if removed component was selected
    const removedComponents = R.differenceWith((a, b) => a.id === b.id, this.props.items, nextProps.items);

    if (removedComponents.length > 0 && this.state.selected) {
      const wasSelectedRemoved = removedComponents.some((c) => c.id === this.state.selected);
      if (wasSelectedRemoved) {
        // eslint-disable-next-line react/no-will-update-set-state
        this.setState({ selected: null });
      }
    }
  }

  static props;

  handleEditComponent(id) {
    this.setState({ selected: id });
  }

  handleSelect(id) {
    this.setState({ selected: id || null });
  }

  render() {
    const { items, ...props } = this.props;

    return (
      <PureList
        containerClassName="ComponentsList"
        items={R.sortBy(R.prop('index'), items)}
        renderRow={LearningComponentItem}
        rowProps={(item) => ({
          ...props,
          selected: this.state.selected === item.id,
          onSelect: this.handleSelect,
        })}
      />
    );
  }
}

export default PerformanceComponentsList;
